module.exports = __webpack_public_path__ + "front/img/p3.8717fa74.png";